import { ObjectDatesCertificateInterface } from "components/componentesGenerales/firmaElectronica/interfaces/firmaInterfaces";

const digest = {
  MD5: 1,
  SHA1: 2,
  SHA2: 3,
};

const encoding = {
  UTF8: 2,
  B64: 3,
};

const rstrtohex = (s: string) => {
  var result = "";
  for (var i = 0; i < s.length; i++) {
    result += ("0" + s.charCodeAt(i).toString(16)).slice(-2);
  }
  return result;
};

const hexToBase64 = (hex: any) => {
  var base64map =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  if (typeof hex == "undefined") return;
  let bytes = [];
  let base64 = [];
  let i = 0;
  for (let c = 0; c < hex.length; c += 2) {
    bytes.push(parseInt(hex.substr(c, 2), 16));
  }

  for (i = 0; i < bytes.length; i += 3) {
    let triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
    for (let j = 0; j < 4; j++) {
      if (i * 8 + j * 6 <= bytes.length * 8)
        base64.push(base64map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
      else base64.push("=");
    }
  }
  return base64.join("");
};

const firelKey = (
  strKey: any,
  certModule: any,
  cert: any,
  password: string,
  addOPrivateKey: any,
  addStrCertificate: any
) => {
  let format = (window as any).ASN1HEX.getDecendantHexTLVByNthList(strKey, 0, [
    0,
  ]);

  let citer = (window as any).ASN1HEX.getDecendantHexTLVByNthList(format, 0, [
    1,
  ]);

  let iteraciones = (window as any).ASN1HEX.getDecendantHexTLVByNthList(
    citer,
    0,
    [1]
  );

  let salt = (window as any).ASN1HEX.getDecendantHexTLVByNthList(citer, 0, [0]);
  citer = decodeItem(decodeItem(salt));

  let saltos = (window as any).ASN1HEX.getDecendantHexTLVByNthList(
    iteraciones,
    0,
    [0]
  );
  const encryptedData = (window as any).ASN1HEX.getDecendantHexTLVByNthList(
    strKey,
    0,
    [1]
  );
  const privateKey = encryptedData.substring(
    encryptedData.indexOf(
      (window as any).ASN1HEX.getDecendantHexTLVByNthList(encryptedData, 0, [0])
    )
  );

  saltos = parseInt(saltos, 16);
  if (isNaN(saltos)) {
    let errorMessage: string = "Error al decodificar la llave privada";
    return errorMessage;
  }
  const deriveKey = deriveKeyV1(
    password,
    (window as any).forge.util.hexToBytes(citer),
    saltos,
    64
  );
  try {
    let cipher = (window as any).forge.des.createDecryptionCipher(deriveKey[0]);
    cipher.start(deriveKey[1]);
    cipher.update(
      (window as any).forge.util.createBuffer(
        (window as any).forge.util.hexToBytes(privateKey)
      )
    );
    cipher.finish();
    let result = cipher.output.toHex();
    if (result.indexOf("30") !== 0) {
      let errorMessage: string =
        "Archivos .KEY, .CER y/o contraseña incorrectos (No se ha podido acceder a la llave privada).";
      return errorMessage;
    } else {
      let pkey = privateKeyObject(
        (window as any).hex2b64(cipher.output.toHex())
      );
      let moduloPkey = pkey.n;
      if (!validateModules(certModule, moduloPkey.data)) {
        let errorMessage: string =
          "No existe relación entre el certificado y la llave privada seleccionada";
        return errorMessage;
      } else {
        addOPrivateKey(hexToBase64(result));
        addStrCertificate(cert);
        return [0, "La verificación del par de llaves ha sido satisfactoria"];
      }
    }
  } catch (e) {
    throw e;
  }
};

function validateModules(a: any, b: any) {
  let iguales = true;
  let i = 0;
  while (typeof a[i] != "undefined" && typeof b[i] != "undefined") {
    if (a[i] !== b[i]) {
      iguales = false;
      break;
    }
    i++;
  }
  return iguales;
}

const decodeItem = (dataCoded: any) => {
  let offset = 0x02;
  let sizeData = "0x" + (window as any).forge.util.bytesToHex(dataCoded[1]);
  let data = [];

  //@ts-ignore
  if (sizeData > 0x80) {
    //@ts-ignore
    const dByte = sizeData - 0x80;
    offset = 0o2 + dByte;
    //@ts-ignore
    sizeData = 0o0;
    for (var n = 0; n < dByte; n++) {
      //@ts-ignore
      sizeData = (sizeData << 0x08) | dataCoded[0o2 + n];
    }
  }

  data = dataCoded.slice(offset);
  return data;
};

function privateKeyObject(strPrivateKey: any) {
  var pkeyDerEncoded = (window as any).forge.util.decode64(strPrivateKey);
  var pkeyAsn1Encoded = (window as any).forge.asn1.fromDer(pkeyDerEncoded);
  var privateKey = (window as any).forge.pki.privateKeyFromAsn1(
    pkeyAsn1Encoded
  );
  return privateKey;
}

function deriveKeyV1(
  password: any,
  salt: any,
  iterations: any,
  keySizeInBits: any
) {
  let keySize = keySizeInBits / 8;
  let md = (window as any).forge.md.md5.create();
  md.start();
  md.update(password);
  let result = md.update(salt);
  let aux = result.digest().data;
  for (let i = 1; i < iterations; i++) {
    md.start();
    aux = md.update(aux).digest().data;
  }

  let key = null;
  let iv = [];
  key = aux.substr(0, keySize);
  iv = aux.substr(keySize);
  return [key, iv];
}

const getFechasCertificado = (strCertificate: string | undefined) => {
  try {
    var certDerBytes = (window as any).forge.util.decode64(strCertificate);
    var obj = (window as any).forge.asn1.fromDer(certDerBytes);
    var cert = (window as any).forge.pki.certificateFromAsn1(obj);
    var dateFin = cert.validity.notAfter;
    var dateIni = cert.validity.notBefore;

    let objDates: ObjectDatesCertificateInterface;
    objDates = {
      fechaInicial: dateIni.getTime(),
      fechaFinal: dateFin.getTime(),
    };

    return objDates;
  } catch (e) {
    console.error("Se murio getFechasCertificado() :(");
    console.error(e);
    return {
      error: "No se ha podido obtener la fecha de vencimiento del certificado",
    };
  }
};

const padding = (val: any) => {
  return val.length === 1 ? "0" + val : val;
};

const getFechaFirma = () => {
  let oDate = new Date();
  let strDate =
    oDate.getFullYear().toString().substring(2) +
    "" +
    padding(oDate.getMonth().toString()) +
    "" +
    padding(oDate.getDate().toString()) +
    "" +
    padding(oDate.getHours().toString()) +
    "" +
    padding(oDate.getMinutes().toString()) +
    "" +
    padding(oDate.getSeconds().toString()) +
    "Z";

  return strDate;
};

const signPKCS1 = (
  oPrivateKey: any,
  strText: any,
  iAlgoritm: any,
  iCodification: any
) => {
  try {
    let kindDigest;
    const privateKey = privateKeyObject(oPrivateKey);
    let digesFunction: any = {
      16: (window as any).forge.md.md5.create(),
      20: (window as any).forge.md.sha1.create(),
      32: (window as any).forge.md.sha256.create(),
    };
    kindDigest = digesFunction[iAlgoritm];

    if (kindDigest === undefined) {
      kindDigest = (window as any).forge.md.sha1.create();
    }

    if (iCodification === encoding.B64) {
      try {
        kindDigest.update(
          (window as any).forge.util.text.utf8.decode(
            (window as any).forge.util.binary.base64.decode(strText)
          ),
          "utf8"
        );
      } catch (error) {
        kindDigest.update((window as any).forge.util.decode64(strText), "raw");
      }
    } else {
      kindDigest.update(strText, "utf8");
    }

    return {
      status: "success",
      data: (window as any).forge.util.encode64(privateKey.sign(kindDigest)),
    };
  } catch (error) {
    return { status: "error", message: error };
  }
};

const getCertificateAttributeFromSubject = (
  strB64Certificate: any,
  strOID: any
) => {
  let cert = getCertificateObject(strB64Certificate);
  if (cert == null && strB64Certificate != null) {
    cert = getCertificateObject(strB64Certificate);
    strOID = strB64Certificate;
  }
  if (cert == null) {
    return null;
  }
  return getAttributeFromSubject(cert, strOID);
};

const getCertificateObject = (strB64Certificate: any) => {
  try {
    var certDerBytes = (window as any).forge.util.decode64(strB64Certificate);
    var obj = (window as any).forge.asn1.fromDer(certDerBytes);
    var cert = (window as any).forge.pki.certificateFromAsn1(obj);
    return cert;
  } catch (e) {
    return null;
  }
};

const getAttributeFromSubject = (certificate: any, strOID: any) => {
  for (var i = 0; i < certificate.subject.attributes.length; i++) {
    if (certificate.subject.attributes[i].type === strOID) {
      var attribute = certificate.subject.attributes[i].value;
      if (certificate.subject.attributes[i].valueTagClass === 12) {
        attribute = (window as any).forge.util.decodeUtf8(attribute);
      }
      return attribute;
    }
  }
  return null;
};

const base64ToFile = (base64: any, filename: any) => {
  var arr = base64.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

export {
  rstrtohex,
  hexToBase64,
  firelKey,
  getFechasCertificado,
  padding,
  getFechaFirma,
  digest,
  signPKCS1,
  encoding,
  getCertificateAttributeFromSubject,
  base64ToFile,
};
